module.exports = __webpack_public_path__ + "img/mitel.e288d7d5.png";